<template>
	<div class="table-questions">
		<v-layout
			wrap align-center
			class="title-questions"
			:style="`color:${$appColors.primary}`"
		>
			<v-flex text-xs-left>
				{{ titleQuestion }}
			</v-flex>
			<v-flex v-if="showBtn" text-xs-right pr-2>
				<app-tooltip-button
					img="/static/img/factor/settings.svg"
					text="Cambiar preguntas"
					@click-icon="$emit('on-click')"
				></app-tooltip-button>
			</v-flex>
		</v-layout>
		<div
			:style="`max-height: ${height}`"
			class="wrapper-questions">
			<div
				class="row-questions"
				:style="`color:${$appColors.info}`"
				v-for="(question, index) in questions" :key="question.id">
				{{ index + 1 }}. <p class="name-question">{{ question.name }}</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'table-question',
	props: {
		height: {
			type: String,
			default: 'none',
		},
		questions: {
			type: Array,
			default: () => [],
		},
		showBtn: {
			default: false,
			type: Boolean,
		},
		titleQuestion: String,
	},
};
</script>

<style lang="scss" scoped>
.table-questions {
	background-color: map-get($colors, white);
	border: 1px solid map-get($colors, gray-light);
	border-radius: 9px;
	margin-bottom: 15px;
	width: 100%;
}

.title-questions {
	background-color: map-get($colors, gray-light);
	border: solid 1px map-get($colors, gray-slider);
	border-top-left-radius: 9px;
	border-top-right-radius: 9px;
	font-family: map-get($fonts, bold);
	font-size: map-get($sizes, xlarge);
	padding: 20px 0 20px 33px;
}

.row-questions {
	border-bottom: 1px solid map-get($colors, gray-light);
	display: flex;
	font-size: map-get($fonts, small);
	padding: 10px 20px;
}

.wrapper-questions {
	overflow-y: auto;
}

.name-question {
	margin: 0 0 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/surveys/table-question.vue